import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { CheckBladderSizeActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-check-bladder-size-slot-v2',
    templateUrl: './check-bladder-size-slot-v2.component.html',
    styleUrl: './check-bladder-size-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckBladderSizeSlotComponentV2 implements SheetSlotComponentBase {

	@Input() action!: CheckBladderSizeActionV2;
	value = null;

	constructor() {
	}
}